<template>
  <v-row v-if="spotArea?.id">
    <v-col sm="6" lg="6" class="d-flex align-content-center flex-row justify-center">
      <label class="mr-2 pt-2">
        <strong>{{ t('yard.forms.yardViewSpotAreaForm.labels.areaName') }}:</strong>
      </label>

      <v-text-field
        color="primary"
        data-testid="yard-area-form-name-input"
        hide-details
        density="compact"
        :placeholder="t('yard.forms.yardViewSpotAreaForm.placeholders.eGParkingZoneEastLoadingBay')"
        required
        variant="outlined"
        v-model="spotAreaName"
        @keydown.enter.prevent="submit" />
    </v-col>

    <v-col cols="6" class="d-flex justify-end">
      <v-btn variant="outlined" class="mr-4" @click="back">
        {{ t('global.buttons.nevermind') }}
      </v-btn>
      <v-btn
        class="bg-primary"
        @click="submit"
        :disabled="!spotAreaName"
        data-testid="yard-area-form-save">
        {{ t('yard.forms.yardViewSpotAreaForm.buttons.saveArea') }}
      </v-btn>
    </v-col>
  </v-row>
  <div v-else class="d-flex flex-column justify-center align-center">
    <p class="typography-body-sm-bold my-6">
      {{ t('yard.forms.yardViewSpotAreaForm.labels.enterANameForThisArea') }}:
    </p>

    <v-text-field
      data-testid="yard-area-form-name-input"
      required
      color="primary"
      :placeholder="t('yard.forms.yardViewSpotAreaForm.placeholders.eGParkingZoneEastLoadingBay')"
      min-width="300px"
      variant="outlined"
      v-model="spotAreaName"
      @keydown.enter.prevent="submit" />

    <div>
      <v-btn variant="outlined" class="mr-4" @click="back">
        {{ t('global.buttons.nevermind') }}
      </v-btn>
      <v-btn
        class="bg-primary"
        @click="submit"
        :disabled="!spotAreaName"
        data-testid="yard-area-form-save">
        {{ t('yard.forms.yardViewSpotAreaForm.buttons.saveArea') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { ref, defineComponent, onBeforeMount } from 'vue';

import useYard from '@/modules/yard/composables/useYard';
import { useRouter } from 'vue-router';
import { useEventHub } from '@/composables';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewSpotAreaForm',
  props: { spotArea: { type: Object, required: true } },
  emits: ['update'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const yardStore = useYard();
    const router = useRouter();
    const spotAreaName = ref('');
    const eventHub = useEventHub();

    const defaultWarehouseId = yardStore.defaultWarehouseIdRef.value;
    const defaultSpotAreaId = yardStore.defaultSpotAreaIdRef.value;

    const back = () => {
      if (props.spotArea?.id) {
        eventHub.$emit('yard-spot-area-form-close');
      } else {
        router.push({ name: 'yard-warehouse', params: { warehouseId: defaultWarehouseId } });
      }
    };

    const submit = async () => {
      const name = spotAreaName.value;
      const value = defaultSpotAreaId
        ? await yardStore.updateSpotArea(defaultSpotAreaId, { name })
        : await yardStore.createSpotArea({ name });

      const updatedSpotArea = { ...props.spotArea, ...value };

      emit('update', { value: updatedSpotArea });

      yardStore.trackMixpanelEvent(
        defaultSpotAreaId
          ? yardStore.MixPanelEvent.UPDATE_AREA
          : yardStore.MixPanelEvent.CREATE_AREA,
        {
          spotArea: updatedSpotArea
        }
      );

      if (!defaultSpotAreaId) {
        return router.replace({
          name: 'yard-spot-area-detail',
          params: { warehouseId: defaultWarehouseId, spotAreaId: value.id }
        });
      }

      back();
    };

    onBeforeMount(() => {
      if (props.spotArea?.id) {
        spotAreaName.value = props.spotArea.name;
      }
    });

    return {
      t,
      submit,
      back,
      spotAreaName
    };
  }
});
</script>
